<template>
  <div class="modal-wrap" ref="modal" v-show="show">
    <div
      class="modal-cover"
      @click="handleCloseBtnClick"
    ></div>

    <!-- 注意：在iphone6s iphone5上添加 auto_scale ，会导致由下向上弹窗异常 -->
    <div class="modal">
      <div class="modal-content">
        <div
          class="modal-close"
          v-if="showClose"
          @click="handleCloseBtnClick('closeBtn')"
        ></div>
        <slot name="modal-content" />
      </div>
    </div>

    <!-- <span
      class="modal-back"
      v-show="showBack"
      @click="handleBackClick"
    ></span> -->
  </div>
</template>

<script>
// import { os } from '@ali/amap-lib';
import pageScrollCtrl from '../../../common/js/pageScrollCtrl';

const Modal = {
  name: 'Modal',
  props: {
    // 弹窗对应的关闭 flag
    name: {
      type: String,
    },
    // 点击背景是否可以关闭
    coverCloseable: {
      type: Boolean,
      default: true,
    },
    // 是否展示返回按钮
    showBack: {
      type: Boolean,
      default: false,
    },
    // 是否展示关闭按钮
    showClose: {
      type: Boolean,
      default: false,
    },
    // 关闭按钮处理函数
    closeBtnHandler: {
      type: Function,
    },
    // 点击 cover 处理
    coverHandler: {
      type: Function,
    },
  },
  methods: {
    /**
     * 处理关闭通用处理
     * */
    handleClose() {
      this.$emit('modalClose');
    },
    /**
     * 处理点击蒙层处理
     * */
    handleCoverClick() {
      if (!this.coverCloseable) {
        return false;
      }

      if (this.coverHandler) {
        this.coverHandler();
        return false;
      }
      this.$emit('modalClose', 'cover');
    },
    /**
     * 处理一下关闭按钮
     */
    handleCloseBtnClick() {
      if (this.closeBtnHandler) {
        this.closeBtnHandler();
        return false;
      }
      this.$emit('modalClose', 'closeBtn');
    },
    /**
     * 处理返回
     */
    handleBackClick() {
      this.$emit('modalBack', 'back');
    },
    resizePosition() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
      const { modal } = this.$refs;
      modal.style.top = `${scrollTop}px`;
    },
  },
  data() {
    return {
      show: true,
      scrollTop: 0,
    };
  },
  // mounted() {
  //   const { height: screenHeight } = window.screen;
  //   if (os.ios) {
  //     document.documentElement.style.height = `${screenHeight}px`;
  //     document.body.style.height = `${screenHeight}px`;
  //     this.$refs.modal.style.height = `${screenHeight}px`;
  //   }
  // },
  beforeCreate() {
    pageScrollCtrl.lock('modal');
    // this.scrollTop = document.documentElement.scrollTop
    //   || window.pageYOffset
    //   || document.body.scrollTop;
    // document.body.style.position = 'fixed';
    // document.body.style.top = `${-this.scrollTop}px`;
  },
  beforeDestroy() {
    pageScrollCtrl.unlock('modal');
    // document.body.style.position = '';
    // document.body.style.top = '';
    // window.scrollTo(0, this.scrollTop); // 回到原先的top
  },
};

export default Modal;
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../common/css/common-mixin";

.modal-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1000;
  background: rgba(#000,0.8);

  .modal-cover {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }

  .modal {
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: rpx(85);
    width: rpx(521);
    height: rpx(590);
    z-index: 1000;

    .modal-content {
      // background: url("../../assets/modal/common-bg.png") center no-repeat;
      background-size: 100% 100%;
      height: 100%;
    }

    .modal-close {
      position: absolute;
      margin: auto;
      right: rpx(25);
      top: rpx(24);
      width: rpx(24);
      height: rpx(24);
      background: url("../../../assets/img/coupon-close.png") center top
        no-repeat;
      background-size: rpx(24) rpx(24);
      z-index: 3;
    }
  }

  .modal-back {
    opacity: 0;
    position: absolute;
    top: rpx(30px);
    left: rpx(40px);
    width: rpx(21px);
    height: rpx(38px);
    // background: url("../../assets/modal/common-back.png") center no-repeat;
    background-size: 100% 100%;
    animation: fadeIn 0.1s 0.4s linear forwards;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

// // 召回弹窗背景图
// .modal-callback {
//   .modal {
//     width: rpx(560);
//     height: rpx(755);
//     .modal-content {
//       background: url("../../assets/modal/common-bg-callback.png") center no-repeat;
//       background-size: 100% 100%;
//     }
//   }
// }
// // 奖品弹窗背景图
// .modal-reward{
//   .modal {
//     width: rpx(674);
//     height: rpx(753);
//     .modal-content {
//       background: url("../../assets/modal/common-bg-reward.png") center no-repeat;
//       background-size: 100% 100%;
//     }
//   }
// }

// // 参与活动可获得奖品展示
// .modal-prize {
//   .modal {
//     width: rpx(674);
//     height: rpx(753);
//     .modal-content {
//       background: url("../../assets/modal/common-bg-prize.png") center no-repeat;
//       background-size: 100% 100%;
//     }
//   }
// }

// // 投票弹窗背景图
// .modal-vote {
//   .modal {
//     width: rpx(634);
//     height: rpx(749);
//     .modal-content {
//       background: url("../../assets/modal/vote/vote-bg.png") center no-repeat;
//       background-size: 100% 100%;
//     }
//   }
// }

// // 引导登录弹窗背景图
// .modal-login {
//   .modal {
//     width: rpx(521);
//     height: rpx(709);
//     .modal-content {
//       background: url("../../assets/modal/common-bg-login.png") center no-repeat;
//       background-size: 100% 100%;
//     }
//   }
// }

// // 任务、投票历史弹窗不需要居中的背景图
// .modal-task, .modal-votehistory {
//   .modal {
//     .modal-content {
//       background: none;
//     }
//   }
// }
</style>
